import { useEffect, useState } from "react";
import { ShoppingCart } from "lucide-react";
import { api } from "@/lib/api";
import { useI18n } from "@/i18n/I18nContext";

// Multi-business carts: ONE Stripe payment (counted once in the revenue), shown here split per REF.
export const CartSplitCard = () => {
  const { t, fmtDate, locale } = useI18n();
  const [list, setList] = useState(null);
  useEffect(() => { api.get("/admin/revenue/carts", { params: { limit: 20 } }).then(({ data }) => setList(data)).catch(() => setList([])); }, []);
  if (!list?.length) return null;
  const fmt = (n, cur) => new Intl.NumberFormat(locale, { style: "currency", currency: cur.toUpperCase() }).format(n);
  return (
    <section className="card-carbon min-w-0 space-y-3 rounded-2xl p-4" data-testid="admin-cart-split">
      <h2 className="flex items-center gap-2 font-display text-sm font-bold uppercase tracking-wider text-[var(--gold-bright)]"><ShoppingCart className="h-4 w-4 shrink-0" /> {t("cart.adminTitle")}</h2>
      <ul className="min-w-0 space-y-3">
        {list.map((c) => (
          <li key={c.id} className="min-w-0 rounded-xl border border-neutral-800 p-3 text-sm" data-testid={`admin-cart-${c.id}`}>
            <p className="break-all font-semibold text-white">{c.email} · {fmtDate(c.paid_at)} · {fmt(c.total_ht, c.currency)} {t("cart.ht")}</p>
            <ul className="mt-1 space-y-0.5 text-xs text-neutral-300">
              {c.lines.map((l) => <li key={l.ref} className="break-words" dir="auto">{l.app} · {l.ref} · {l.months} · +{l.employees} → {fmt(l.amount_ht, c.currency)}</li>)}
            </ul>
          </li>
        ))}
      </ul>
    </section>
  );
};
